export default "__VITE_ASSET__BQzReJYx__"